import AddIcon from "@mui/icons-material/Add";
import { AppBar, Container, Grid, Paper } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { Button } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import DialogAuthorizeSale from "../../component/dialog-authorize-sale/dialog-authorize-sale";
import ResponsiveDialog from "../../component/dialog/dialog";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import SimpleBackdrop from "../../component/loading/loading";
import NewTableComponent from "../../component/table-sale/table-sale";
import { usePermissions } from "../../contexts/permissionsContext";
import usePermissionCheck from "../../hooks/usePermissionCheck";
import saleService from "../../service/saleService";

function ListSale() {
  const navigate = useNavigate();
  const { permissions, isLoading } = usePermissions();
  const { checkPermissionWithRefresh, permissionError, clearPermissionError } = usePermissionCheck();
  const [permission, setPermission] = useState(null);

  const [listSale, setListSale] = useState({
    data: [],
   pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    hasNext: false,
    hasPrev: false,
  }});

  const [loading, setLoading] = useState(1);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filters, setFilters] = useState({});
  const [sortBy, setSortBy] = useState('codIntern');
  const [sortOrder, setSortOrder] = useState('DESC');
  const isMountedRef = useRef(true);
  const activeControllerRef = useRef(null);

  // Estados para o modal de autorização de venda
  const [openAuthorizeSale, setOpenAuthorizeSale] = useState(false);
  const [saleToAuthorize, setSaleToAuthorize] = useState(null);
  const [authorizingLoading, setAuthorizingLoading] = useState(false);
  
  // Estados para dialog de sucesso
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [successTitle, setSuccessTitle] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Funções para controlar o modal de autorização
  const handleOpenAuthorizeSale = async (saleData) => {
    try {
      // Verificar permissão "Enviar Vendas" antes de abrir o modal
      const hasPermission = await checkPermissionWithRefresh("Enviar Vendas", "isinsert", true, false);
      
      if (hasPermission) {
        setSaleToAuthorize(saleData);
        setOpenAuthorizeSale(true);
      }
    } catch (error) {
      console.error('Erro ao verificar permissão:', error);
    }
  };

  const handleCloseAuthorizeSale = () => {
    setOpenAuthorizeSale(false);
    setSaleToAuthorize(null);
  };

  const handleAuthorizeSale = async (saleData) => {
    try {
      setAuthorizingLoading(true);
      setErrorMessage('');

      // Preparar dados para envio
      const requestData = {
        issend: true,
        idsale: saleData.idsale,
        sellerCommission: saleData.commissionValue, // Valor que pode ser alterado no modal
      };

      // Enviar venda
      const response = await saleService.sendSale(requestData);
      
      if (response.status === 200 || response.status === 201 || response.success === true) {
        // Fechar modal
        handleCloseAuthorizeSale();
        
        // Mostrar dialog de sucesso
        setSuccessTitle('Muito bem!');
        setSuccessMessage(response.message || 'Venda enviada com sucesso!');
        setOpenSuccessDialog(true);
        
        // Recarregar a página após 2 segundos
        setTimeout(() => {
          setOpenSuccessDialog(false);
          window.location.reload();
        }, 2000);
      } else {
        // Mostrar erro
        setErrorMessage(response.message || 'Erro ao enviar venda');
      }
    } catch (error) {
      console.error('Erro ao autorizar venda:', error);
      setErrorMessage('Erro ao enviar venda. Tente novamente.');
    } finally {
      setAuthorizingLoading(false);
    }
  };

  useEffect(() => {
    // Encontrar a permissão de Vendas especificamente
    const vendasPermission = permissions.find(role => role.name === "Vendas");
    console.log("🔍 [ListSale] Permissões carregadas:", permissions);
    console.log("🔍 [ListSale] Permissão de Vendas encontrada:", vendasPermission);
    setPermission(vendasPermission);
  }, [permissions]);

  useEffect(() => {
    isMountedRef.current = true;
    if (isLoading) return;

    (async () => {
      setOpen(true);

      try {
        // Cancela qualquer requisição anterior
        if (activeControllerRef.current) {
          activeControllerRef.current.abort();
        }
        const controller = new AbortController();
        activeControllerRef.current = controller;

        console.log("🔍 [ListSale] Carregando com ordenação padrão:", { sortBy, sortOrder });
        const item = await saleService.list(1, 10, {}, sortBy, sortOrder, { signal: controller.signal });

        if (!isMountedRef.current) return;

        if (item && item.success !== false) {
          // Se a API retorna dados paginados
          if (item.data && Array.isArray(item.data) && item.pagination) {
            setListSale({
              data: item.data,
              pagination: item.pagination,
            });
          }
          // Se a API retorna apenas um array (compatibilidade)
          else if (Array.isArray(item)) {
            setListSale({
              data: item,
              pagination: {
                currentPage: 1,
                totalPages: 0,
                totalItems: 0,
                itemsPerPage: 10,
                hasNext: false,
                hasPrev: false,
              }
            });
          }
          else {
            console.error("Resposta inválida da API:", item);
            setListSale({
              data: [],
              pagination: {
                currentPage: 1,
                totalPages: 0,
                totalItems: 0,
                itemsPerPage: 10,
                hasNext: false,
                hasPrev: false,
              }
            });
          }
        }
        else if (item && item.success === false) {
          console.error("Erro na API:", item.message);
          setErrorMessage(item.message);
          setListSale({
            data: [],
            pagination: {
              currentPage: 1,
              totalPages: 0,
              totalItems: 0,
              itemsPerPage: 10,
              hasNext: false,
              hasPrev: false,
            }
          });
        }
        else {
          console.error("Resposta inválida da API:", item);
          setListSale({
            data: [],
            pagination: {
              currentPage: 1,
              totalPages: 0,
              totalItems: 0,
              itemsPerPage: 10,
              hasNext: false,
              hasPrev: false,
            }
          });
        }
      } catch (error) {
        // Silencia cancelamentos
        if (error?.code !== "CANCELED") {
          console.error("Erro na requisição:", error);
          if (!isMountedRef.current) return;
          setListSale({
            data: [],
            pagination: {
              currentPage: 1,
              totalPages: 0,
              totalItems: 0,
              itemsPerPage: 10,
              hasNext: false,
              hasPrev: false,
            }
          });
          setErrorMessage(error.message || "Erro ao carregar vendas");
        }
      } finally {
        if (!isMountedRef.current) return;
        setOpen(false);
        setLoading(0);
      }
    })();
    return () => {
      isMountedRef.current = false;
      if (activeControllerRef.current) {
        activeControllerRef.current.abort();
      }
    };
  }, [isLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const loadPage = async (page, pageSize, customFilters, customSortBy, customSortOrder) => {
    // Se customFilters foi passado explicitamente, usa ele; senão usa o estado
    const filtersToUse = customFilters !== undefined ? customFilters : filters;
    const sortByToUse = customSortBy !== undefined ? customSortBy : sortBy;
    const sortOrderToUse = customSortOrder !== undefined ? customSortOrder : sortOrder;
    
    console.log("🔄 [ListSale] Carregando página:", page, "Tamanho:", pageSize);
    console.log("🔍 [ListSale] customFilters recebido:", customFilters);
    console.log("🔍 [ListSale] filters do estado:", filters);
    console.log("🔍 [ListSale] Filtros que serão usados:", filtersToUse);
    console.log("📊 [ListSale] Ordenação:", { sortBy: sortByToUse, sortOrder: sortOrderToUse });
    
    setOpen(true);
    
    try {
      // Cancela qualquer requisição anterior de paginação/filtro
      if (activeControllerRef.current) {
        activeControllerRef.current.abort();
      }
      const controller = new AbortController();
      activeControllerRef.current = controller;

      const item = await saleService.list(page, pageSize, filtersToUse, sortByToUse, sortOrderToUse, { signal: controller.signal });
      console.log("📡 [ListSale] Resposta da API:", item);
      
      if (!isMountedRef.current) return;

      if (item && item.success !== false) {
        if (item.data && Array.isArray(item.data) && item.pagination) {
          console.log("✅ [ListSale] Dados recebidos:", {
            dataLength: item.data.length,
            pagination: item.pagination,
            filters: filtersToUse
          });
          setListSale({
            data: item.data,
            pagination: item.pagination,
          });
        }
      } else {
        console.error("❌ [ListSale] Erro na API:", item);
        setErrorMessage(item?.message || "Erro ao carregar dados");
      }
    } catch (error) {
      if (error?.code !== "CANCELED") {
        console.error("❌ [ListSale] Erro ao carregar dados:", error);
        if (!isMountedRef.current) return;
        setErrorMessage(error.message || "Erro ao carregar dados");
      }
    } finally {
      if (!isMountedRef.current) return;
      setOpen(false);
    }
  };

  const handleFilterChange = (newFilters) => {
    console.log("🔍 [ListSale] Filtros alterados:", newFilters);
    console.log("🔍 [ListSale] Chamando API IMEDIATAMENTE com novos filtros");
    
    // Atualizar estado
    setFilters(newFilters);
    
    // Recarregar dados com novos filtros IMEDIATAMENTE (não espera setState)
    // Passa newFilters diretamente, não usa o estado
    loadPage(1, listSale.pagination.itemsPerPage || 10, newFilters, sortBy, sortOrder);
  };

  const handleSortChange = (field, order) => {
    console.log("📊 [ListSale] Ordenação alterada:", { field, order });
    
    // Atualizar estado
    setSortBy(field);
    setSortOrder(order);
    
    // Recarregar dados com nova ordenação IMEDIATAMENTE
    loadPage(1, listSale.pagination.itemsPerPage || 10, filters, field, order);
  };

  if (isLoading) {
    return (
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <SimpleBackdrop open={true} handleClose={() => { }} title={"Carregando usuário..."} />
        </div>
      </Container>
    );
  }

  return (
    <>
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
        <DrawerPrincipal
          title={"Venda"}
          divOpen={
            <div>
              <div>
                <SimpleBackdrop
                  open={open}
                  handleClose={handleClose}
                  title={"Carregando informações..."}
                />
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Lista de Vendas"}
                    link2={"#"}
                  />
                </div>
                <Paper
                  sx={{ width: "100%", margin: "auto", overflow: "hidden" }}
                >
                  <AppBar
                    position="static"
                    color="default"
                    elevation={0}
                    sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
                  >
                    <Toolbar>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item style={{ width: 200 }}>
                          <h5>Lista de Vendas</h5>
                        </Grid>
                        <Grid item xs></Grid>
                        <Grid item></Grid>
                        <Grid item>
                          {permission?.isinsert ? (
                            <Button
                              style={{ background: "black", color: "#FFF" }}
                              sx={{ mr: 1 }}
                              onClick={async () => {
                                const hasPermission = await checkPermissionWithRefresh("Vendas", "isinsert", true, false);
                                if (hasPermission) {
                                  navigate("/sale");
                                }
                              }}
                            >
                              <AddIcon /> Novo
                            </Button>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Toolbar>
                  </AppBar>

                  <div style={{ width: "100%", padding: 10 }}>
                    {errorMessage && (
                      <div
                        style={{
                          padding: "10px",
                          marginBottom: "10px",
                          backgroundColor: "#ffebee",
                          color: "#c62828",
                          border: "1px solid #ef5350",
                          borderRadius: "4px",
                        }}
                      >
                        <strong>Erro:</strong> {errorMessage}
                      </div>
                    )}

                    <NewTableComponent 
                      data={listSale} 
                      onPageChange={loadPage}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onOpenAuthorizeSale={handleOpenAuthorizeSale}
                    />

                    {/* <TableSale key={listSale.length} list={listSale}/> */}
                  </div>
                </Paper>
              </div>
            </div>
          }
        />
      </Container>

      {/* Modal de Autorização de Venda - Fora do Drawer */}
      <DialogAuthorizeSale
        open={openAuthorizeSale}
        handleClose={handleCloseAuthorizeSale}
        handleAuthorize={handleAuthorizeSale}
        saleData={saleToAuthorize}
        loading={authorizingLoading}
      />

      {/* Dialog de Sucesso */}
      <ResponsiveDialog
        open={openSuccessDialog}
        handleClose={() => setOpenSuccessDialog(false)}
        status="success"
        title={successTitle}
        message={successMessage}
      />

      {/* Dialog de erro de permissão */}
      {permissionError && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px',
            textAlign: 'center'
          }}>
            <h3 style={{ color: '#d32f2f', marginBottom: '10px' }}>
              {permissionError.title}
            </h3>
            <p style={{ marginBottom: '20px' }}>
              {permissionError.message}
            </p>
            <button
              onClick={clearPermissionError}
              style={{
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ListSale;
